import React from 'react';

const SvgStatistics: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34" {...props}>
      <defs>
        <clipPath id="statistics_svg__a">
          <path fill="none" d="M0 0h34v34H0z" />
        </clipPath>
      </defs>
      <g
        clipPath="url(#statistics_svg__a)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.25 12.75V8.5a2.834 2.834 0 012.833-2.833h19.834A2.834 2.834 0 0129.75 8.5v17a2.833 2.833 0 01-2.833 2.833h-8.5M12.75 28.333l-.356-.892a3.268 3.268 0 00-3.039-2.058H6.227a3.268 3.268 0 00-3.039 2.058l-.355.892" />
        <path d="M9.546 17.726a2.48 2.48 0 11-3.506 0 2.48 2.48 0 013.506 0M16 21v-8M19.834 21.249v-4.71M24.084 21.249v-7.726" />
      </g>
    </svg>
  );
};

export default SvgStatistics;
